import { defaultProps } from 'recompose';

import EditPage from '../EditPage/component';

export default defaultProps({
  isEditable: true,
  isLoaded: true,
})(EditPage);
